var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFifa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 77 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.026123 0.000305176V24.9979H7.92171V15.9721H13.4078L15.5406 10.5082H7.92171V5.436H17.195L19.2175 0.000305176H0.026123Z",
    fill: "#036AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.632 0L21.6179 24.9976H29.4221V0H21.632Z",
    fill: "#036AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0474 16.8324L63.0537 6.42411L66.1678 16.8324H60.0474ZM67.2324 0H59.1293L50.1445 25H57.6872L58.658 21.6384H67.4505L68.4671 25H76.2407L67.2324 0Z",
    fill: "#036AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8108 0V24.9976H42.7017V15.9718H48.182L50.33 10.5079H42.7017V5.43569H51.9785L54.0163 0H34.8108Z",
    fill: "#036AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.2146,
    height: 25,
    fill: "white",
    transform: "translate(0.0258789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFifa);
export default __webpack_public_path__ + "static/media/fifa.bfa64994e635b2030a01eb7f9271bc86.svg";
export { ForwardRef as ReactComponent };